const config = {
  API_URI: process.env.APP_URL || "http://localhost:3000",
};
export default config;
